/**
 * Creates and inserts breadcrumb items into the DOM.
 *
 * @param {Array<{name: string, slug: string}>} breadcrumbs - An array of breadcrumb objects.
 * @param {string} breadcrumbs[].name - The name of the breadcrumb.
 * @param {string} breadcrumbs[].slug - The URL slug of the breadcrumb.
 */
const createBreadcrumbs = (breadcrumbs) => {
  const breadcrumbsHolder = document.querySelector(".breadcrumbs")
  if (!breadcrumbsHolder) return
  const layout = breadcrumbs
    .map(
      (item) => `
      <li class="breadcrumbs__item" property="itemListElement" typeof="ListItem">
          <a href="${item.slug}" property="item" typeof="WebPage">
            ${item.name}
          </a>
      </li>`,
    )
    .join("")

  breadcrumbsHolder.innerHTML = layout
}

export default createBreadcrumbs
